import Lang from "@vendors-fr/messages";

export const rentalCertificateData = {
    data: {
        'rentalId': null,
        'verificationCode': [],
    },
    dom: {
        'rentalBlockDom': () => {
            const rentalId = rentalCertificateData.data.rentalId;
            return $(`#js_rental_${rentalId}`);
        }
    },
    set: {
        'setRentalId': function (rentalId) {
            rentalCertificateData.data.rentalId = rentalId;
        },
        'setVerificationCode': function (verificationCode) {
            rentalCertificateData.data.verificationCode = verificationCode;
        }
    },
    get: {
        'getRentalId': function () {
            return rentalCertificateData.data.rentalId;
        },
        'getRentalTime': function () {
            return rentalCertificateData.dom.rentalBlockDom().find('.js_rental_time').html();
        },
        'getVerificationCode': function () {
            return rentalCertificateData.data.verificationCode.code;
        },
        'isUsedVerificationCode': function () {
            return rentalCertificateData.data.verificationCode.status === 'used';
        },
        'getUsedVerificationCodeTime': function () {
            if (rentalCertificateData.get.isUsedVerificationCode()) {
                return rentalCertificateData.data.verificationCode.verification_at;
            }
            return '';
        },
        'getProductCount': function () {
            let count = 0;
            rentalCertificateData.dom.rentalBlockDom().find('.js_rental_product').each(function(){
                count += parseInt($(this).find('.js_rental_quantity').html());
            });

            return count;
        },
        'getProducts': function () {
            let products = [];
            rentalCertificateData.dom.rentalBlockDom().find('.js_rental_product').each(function(){
                products.push({
                    'image': $(this).find('.js_rental_img').attr('src'),
                    'name': $(this).find('.js_rental_product_name').html(),
                    'quantity': $(this).find('.js_rental_quantity').html()
                });
            });

            return products;
        }
    },
}

export const getRentalUsedCodeHtml = function (code, verificationTime) {
    return `
            <div class="ui-flex ui-flex-column ui-gap-0_5">
                <div class="ui-fs-0_875 ui-font-bold">核銷代碼：<span class="js_rental_appointment_code">${code}</span></div>
                <div class="ui-fs-0_875" style="color: #808080">核銷日期：${verificationTime}</div>
            </div>
            <div class="c-square-tag c-square-tag--sm c-square-tag--outline c-square-tag--success ui-mv-0_5 ui-mr-1 ui-m-0@mb">核銷成功</div>
        `;
}

export const getRentalUnusedCodeHtml = function (code) {
    return `
            <div class="ui-flex ui-flex-column ui-gap-0_5">
                <div class="ui-fs-0_875 ui-font-bold">核銷代碼：<span class="js_rental_appointment_code">${code}</span></div>
            </div>
            <div class="c-square-tag c-square-tag--sm c-square-tag--outline">尚未核銷</div>
        `;
}

export const getRentalProductDetailHtml = function(product){
    return `
            <div class="c-card ui-flex ui-justify-content-between ui-align-items-center ui-gap-1">
                <div class="ui-flex ui-align-items-center ui-gap-1">
                    <img src="${product.image}" alt="${product.name}" class="js_rental_appointment_product_image" style="width: 50px; height: 50px;">
                    <p class="ui-m-0 js_rental_appointment_product_name">${product.name}</p>
                </div>
                <div><span class="js_rental_appointment_product_quantity">${product.quantity}</span>${Lang.get('frontend.product.rentable.quantity.unit')}</div>
            </div>
        `;
}
